<h4>Adicionar fundo a simulação</h4>

<form id="form" [formGroup]="form" (ngSubmit)="submit()">
  <div
    fxLayout="column"
    fxLayout.lt-md="column"
    fxLayoutGap="5px"
    fxLayoutGap.lt-md="0px"
    style="margin-bottom: 1em;"
  >
    <mat-form-field fxFlex="60">
      <input
        id="fundo"
        matInput
        type="text"
        #fundo
        placeholder="Fundo"
        [value]="filtroFundo | async"
        (keyup)="handleFiltro($event.target.value)"
        [matAutocomplete]="auto"
      />
    </mat-form-field>

    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFundo"
      (optionSelected)="selectFundo($event.option.value)"
    >
      <mat-option *ngFor="let option of fundos$ | async" [value]="option"
        >{{ option.cnpj }} - {{ option.nome }}</mat-option
      >
    </mat-autocomplete>
    <mat-form-field fxFlex="40">
      <input
      #valor
      matInput
      currencyMask
      formControlName="valorInvestido"
      [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
      placeholder="Valor investido"
      required
      aria-label="Valor do investimento"
      />
      <mat-error *ngIf="!form.controls['valorInvestido'].valid"
      >Informe o valor do investimento</mat-error
      >
    </mat-form-field>
  </div>
  <div style="display: flex;">
    <button mat-flat-button color="primary" style="flex: 1" [disabled]="form.invalid">
      <i class="far fa-check-square"></i>
      Adicionar fundo
    </button>
    <button mat-flat-button color="warn" style="width: 35%; margin-left: 5px;" [mat-dialog-close]="false">
      <i class="far fa-window-close"></i>
      Cancelar
    </button>
  </div>
</form>


